export default "__VITE_ASSET__DvjOk0Bo__"